<template>
  <div class="upload-container">
    <!-- @click="$refs.fileUploader.click()" -->
    <div class="upload-preview">
      <!-- <div v-if="picSmall" class="uploadbox"> -->
      <div class="uploadbox">
        <img :src="picSmall ? (picSmall.includes('http')?picSmall:picSmallAll ): imgsHttp">
        <!-- <p class="uploadname">上传头像</p> -->
      </div>
      <!-- <i v-else class="el-icon-plus"></i> -->
    </div>
    <!-- 上传头像 -->
    <p class="editPhoto" @click="$refs.fileUploader.click()">{{ $t('basic.uploadAvatar') }}</p>
    <!-- <button class="btn btn-dark" @click="$refs.fileUploader.click()">{{$t('basic.uploadAvatar')}}</button> -->
    <p class="upload-prompt">{{ $t('createPlant.imageLimit') }}</p>
    <!-- <div>
      <button
        class="upload-button"
        @click.prevent="$refs.fileUploader.click()"
      >
        <i class="iconfont icon-upload"></i>Upload
      </button>
      <p class="upload-prompt">{{$t('createPlant.imageLimit')}}</p>
    </div> -->

    <input type="file" class="upload-input" ref="fileUploader" accept="image/jpeg, image/png"
      @change="uploadImage($event)">
  </div>
</template>
<script>
import config from '@/assets/js/config';
export default {
  props: ['picBig', 'picSmall'],
  data() {
    return {
      imgsHttp: document.location.protocol + '//img.shinemonitor.com/img/2019/12/19/201912191850044046DC0FD27.png',
      picSmallAll: "",
    };
  },
  methods: {
    // 上传图片
    uploadImage(event) {
      let file = event.target.files[0]
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t('createPlant.fileExceed'))
        return
      }
      if (this.$store.state.user.role == 5) {
        return this.$message.error(this.$t(`errCode.${11}`))
      } else {
        this.$request.uploadImage(file).then(res => {
          if (res.err === 0) {
            this.$message.success(this.$t('createPlant.uploadSuccess'))
            this.$emit("update:picBig", res.dat.picBig)
            this.$emit("update:picSmall", res.dat.picSmall)
            let defaultsBaseURL = config.env == "production" ? document.location.protocol + '//img.shinemonitor.com/' : document.location.protocol + '//solar.test.eybond.com/'
            this.picSmallAll = defaultsBaseURL+ res.dat.picSmall
          }
        })
      }

    },
  },
}
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");

.upload-container {
  width: 208px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;

  // margin-bottom: 25px;
  .upload-preview {
    // border: 1px dashed #ccc;
    padding-top: 5px;
    border-radius: 5px;
    // margin-bottom: 25px;
    .sc(0, #666);

    // cursor: pointer;
    &:hover {
      color: @themeColor;
      border-color: @themeColor;
    }

    .uploadbox {
      display: flex;
      flex: 1;
      line-height: 128px;
      width: 128px;
      height: 128px;

      img {
        border-radius: 24px;
        height: 128px;
        vertical-align: middle;
      }

      .uploadname {
        display: block;
        flex: 1;
        height: 30px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: #000;
        color: #fff;
      }
    }

    i {
      line-height: 128px;
      width: 128px;
      text-align: center;
      font-size: 20px;
    }
  }

  // .upload-button {
  //   background: #fff;
  //   border: 1px solid @borderColor;
  //   cursor: pointer;
  //   padding: 8px 15px;
  //   border-radius: 5px;
  //   color: rgba(0, 0, 0, 0.6);
  //   font-size: 14px;
  //   i {
  //     color: #999;
  //     margin-right: 10px;
  //   }
  //   &:hover, &:focus {
  //     i {
  //       color: @themeColor;
  //     }
  //     color: @themeColor;
  //     border-color: @themeColor;
  //     background: #fff;
  //   }
  // }
  .editPhoto {
    color: #33FFB6;
    cursor: pointer;
    margin: 14px 0;
  }

  .editPhoto:hover {
    text-decoration: underline;
  }

  .upload-prompt {
    // margin-top: 38px;
    line-height: 1.4;
    .sc(12px, #70818C);
  }

  .upload-input {
    display: none;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }
}
</style>
